class DelsolSlideshowAutopause extends HTMLElement {
  #abortController;

  connectedCallback() {
    this.#abortController?.abort();

    const slideshow = this.querySelector('slideshow-component[autoplay]');
    if (!slideshow) return;

    this.#abortController = new AbortController();
    const { signal } = this.#abortController;

    this.addEventListener('focusin', () => slideshow.suspend(), { signal });
    this.addEventListener(
      'focusout',
      () => {
        queueMicrotask(() => {
          if (signal.aborted) return;
          if (this.contains(document.activeElement) || this.matches(':hover')) return;
          slideshow.resume();
        });
      },
      { signal }
    );
    this.addEventListener(
      'mouseleave',
      () => {
        queueMicrotask(() => {
          if (signal.aborted) return;
          if (this.contains(document.activeElement)) slideshow.suspend();
        });
      },
      { capture: true, signal }
    );
  }

  disconnectedCallback() {
    this.#abortController?.abort();
    this.#abortController = undefined;
  }
}

if (!customElements.get('delsol-slideshow-autopause')) {
  customElements.define('delsol-slideshow-autopause', DelsolSlideshowAutopause);
}
